{
  "notDefined": "Not defined",
  "delete": "Delete",
  "manage": "Manage",
  "showMore": "Show more",
  "dependencyMap": {
    "label": "Dependency map",
    "modalTitle": "Organisation dependency map"
  },
  "modalForm": {
    "cancelLabel": "Cancel",
    "cancel": "Cancel",
    "saveLabel": "Save changes",
    "confirm": "Confirm",
    "create": "Create"
  },
  "accountMenu": {
    "updatedOrganisationRoles": "Organisation role updated.",
    "reportEvent": "Report event",
    "reportEventIncident": "Report event/incident",
    "reportIncident": "Report incident",
    "signedInAs": "Signed in as",
    "personalDetails": "Personal details",
    "personalDescription": "Your basic information used for identification and communication.",
    "profilePhoto": "Profile photo",
    "profilePhotoDesc": "This photo will be visible to others. Maximum file size is 2 MB.",
    "accountSettings": "Account settings",
    "editPassword": "Change password",
    "switchMode": "Switch to {{mode}} mode",
    "lightMode": "Light",
    "darkMode": "Dark",
    "settings": "Settings",
    "helpCentre": "Help centre",
    "logout": "Log out"
  },
  "chatbotAI": {
    "drawerTitle": "Alex AI",
    "field": {
      "messagePlaceholder": "Ask me anything..."
    },
    "header": {
      "hello": "Hi",
      "description": "How can I assist you today?"
    },
    "suggestedPrompt": {
      "firstTitle": "How compliant are we with DORA right now?",
      "secondTitle": "Can you help me map our measures to ISO/IEC 27001 requirements?",
      "thirdTitle": "What are the key NIS2 requirements we should focus on?",
      "fourthTitle": "Which assets are most exposed based on current risk assessments?",
      "fiveTitle": "Can you evaluate the risk posed by this new threat actor?",
      "sixTitle": "Show me a summary of unresolved incidents"
    }
  },
  "fileUploaded": {
    "uploadFileButton": "Browse"
  },
  "unauthorizedView": {
    "cardAlt": "Access denied card",
    "title": "Access denied",
    "message": "Based on your role, you are not authorised to view this page. Please contact your system administrator."
  },
  "phoneInput": {
    "label": "Phone number"
  },
  "userAddOrganisationRoleModal": {
    "title": "Add a new role for the user",
    "organisationLabel": "Organisation",
    "organisationRequired": "Organisation is a required field",
    "roleLabel": "Role",
    "roleRequired": "Role is a required field",
    "searchPlaceholder": "Search role",
    "noRoles": "No roles found.",
    "submitButtonLabel": "Add role",
    "cancelButtonLabel": "Cancel",
    "createSuccessFlashMessage": "Organisation role added."
  },
  "userForm": {
    "cancelButtonLabel": "Cancel",
    "firstName": {
      "label": "First name",
      "required": "First name is a required field",
      "min": "First name must be at least 2 characters",
      "max": "First name must be at most 64 characters"
    },
    "lastName": {
      "label": "Last name",
      "required": "Last name is a required field",
      "min": "Last name must be at least 2 characters",
      "max": "Last name must be at most 64 characters"
    },
    "email": {
      "label": "Company email",
      "valid": "Email must be valid",
      "required": "Email is a required field"
    },
    "phoneNumber": {
      "label": "Phone number",
      "valid": "Phone number must contain only digits and may start with a \"+\"."
    },
    "position": {
      "label": "Position",
      "optionalLabel": "Position (optional)"
    },
    "department": {
      "label": "Department",
      "optionalLabel": "Department (optional)"
    },
    "organisationRole": {
      "label": "Organisation role",
      "required": "Organisation role is required."
    },
    "gender": {
      "label": "Gender",
      "help": "Used in workforce reports. Leave blank to keep it unset.",
      "unset": "Not specified",
      "male": "Male",
      "female": "Female"
    }
  },
  "noResultFound": {
    "title": "No results found",
    "message": "Try adjusting your search or filter."
  },
  "detailValues": {
    "keyDetailsLabel": "Key details",
    "keyDetailShortLabel": "Key detail",
    "editLabel": "Edit"
  },
  "emissionValue": {
    "incidentsEventsLabel": "incidents / events"
  },
  "editSectionHeaderForm": {
    "title": "Edit name",
    "nameLabel": "Name",
    "customIdLabel": "Custom ID",
    "nationalBusinessIdLabel": "Business registration ID",
    "descriptionLabel": "Description"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "dashboards": "Dashboards",
    "overview": "Overview",
    "accounts": "Accounts",
    "jobs": "Jobs",
    "recovery": "Recovery",
    "pendingActions": "Pending actions",
    "organisationModel": "Organisation model",
    "organisation": "Organisation",
    "governance": "Governance",
    "compliance": "Compliance",
    "learning": "Learning",
    "rasci": "RASCI",
    "assets": "Assets",
    "suppliers": "Suppliers",
    "customers": "Customers",
    "users": "Users",
    "threats": "Threats",
    "measures": "Measures",
    "exceptions": "Exceptions",
    "goals": "Goals",
    "securityProjects": "Security projects",
    "education": "Education and policies",
    "kpis": "KPIs",
    "events": "Incidents",
    "playbooks": "Playbooks",
    "interestedParties": "Interested parties",
    "settings": "Settings",
    "riskManagement": "Risk management",
    "videos": "Videos",
    "marketplace": "Marketplace",
    "campaigns": "Campaigns",
    "policies": "Policies",
    "assessments": "Assessments",
    "bia": "BIA register",
    "rolesAndPermissions": "Roles and permissions",
    "invites": "Invites",
    "accessMatrix": "Access matrix",
    "complianceCalendar": "Compliance calendar",
    "risks": "Risk register",
    "vulnerabilities": "Vulnerabilities",
    "gapAnalysis": "Compliance",
    "policiesAndProcesses": "Policies and processes",
    "isms": "ISMS",
    "bcms": "BCMS",
    "ismsDocumentRegister": "Document register",
    "bcmsDocumentRegister": "Document register",
    "securityPolicy": "Security Policy",
    "groupMain": "Main",
    "groupStructure": "Structure",
    "groupResources": "Resources",
    "groupExternalParties": "External Parties",
    "groupPlanningAndOversight": "Planning & Oversight",
    "groupResponsibilityAndAccess": "Responsibility & Access",
    "groupDecisionsAndDeviations": "Decisions & Deviations",
    "groupAnalysis": "Analysis",
    "groupTreatmentAndMonitoring": "Treatment & Monitoring",
    "groupAssessment": "Assessment",
    "groupDocumentation": "Documentation",
    "groupContent": "Content",
    "groupValidation": "Validation",
    "groupPersonal": "Personal",
    "groupOrganisationAdministration": "Organisation administration",
    "groupAccessAndTeam": "Access & Team",
    "groupSubscription": "Subscription",
    "groupPeopleAndParties": "People & parties",
    "groupStrategy": "Strategy",
    "groupPerformance": "Performance",
    "groupResponsibility": "Responsibility",
    "groupDecisions": "Decisions",
    "groupCompliancePosture": "Compliance posture",
    "groupPolicies": "Policies",
    "groupFrameworks": "Framework specification",
    "groupAssurance": "Assurance",
    "frameworkSpecification": "Framework specification",
    "groupIntegrationsAndTools": "Integrations & tools",
    "groupPeople": "People",
    "incidents": "Incidents",
    "scenarios": "Scenarios",
    "problems": "Problems",
    "campaign": "Training",
    "training": "Training",
    "policyLibrary": "Policy library",
    "policyAdministration": "Policy administration",
    "biaConfiguration": "BIA configuration",
    "classification": "Classification",
    "frameworkLaw95": "95/2019",
    "frameworkLaw69": "69/2018",
    "frameworkIso27001": "ISO/IEC 27001",
    "frameworkUcf": "Unified Control Framework",
    "gen360Catalog": "gen360 catalog",
    "organisationOverview": "Overview",
    "soa": "Statement of Applicability",
    "assetClassifications": "Asset classifications"
  },
  "wizardOverview": {
    "title": "Overview",
    "finishButtonLabel": "Finish",
    "cancelButtonLabel": "Cancel",
    "sideBarContent": {
      "title": "Guidance",
      "desc": "Configuring a Business Impact Analysis (BIA) involves identifying critical business functions, assessing their impact, and defining recovery priorities. Here is how to configure it effectively.",
      "label": "A BIA configuration typically defines:",
      "scaleListItemText": "Scale - severity levels",
      "impactListItemText": "Impact categories",
      "categoryListItemText": "After defining the first two points, assign specific values to each scale within each category.",
      "defineTheScale": {
        "desc": "Please note that the maximum scale value is 6.",
        "infoFirstParagraph": "This provides a sufficiently detailed range, allowing users to make informed decisions about the impact of a specific aspect of the Business Impact Analysis.",
        "infoSecondParagraph": "A smaller scale can also be used, but it is important to define each level clearly so users understand the severity of the impact."
      },
      "impactCategory": {
        "infoFirstParagraph": "If an organisation falls under legally defined critical infrastructure requirements, the BIA should take the following into account:",
        "numberResidentsText": "Number of affected residents",
        "numberInjuredText": "Number of injured and deceased persons",
        "damageStateText": "Damage to the state",
        "infoSecondParagraph": "Common impact categories in ISO/IEC 27001-aligned practice include:",
        "financialText": "Financial",
        "operationalText": "Operational",
        "legalRegulatoryText": "Legal and regulatory",
        "reputationText": "Reputation",
        "securityText": "Security",
        "other": "Other",
        "firstStepsCategoryFooter": "Some sector-specific values may be defined by applicable legislation. Follow the applicable legal requirements and then click \"Continue\".",
        "descFirstParagraph": "Defining impact categories and their specific values depends heavily on each organisation. You can define values numerically, as a percentage of the organisation's total value, or using descriptive text.",
        "descSecondParagraph": "The clearer each impact category is defined, the more accurate and relevant the results will be when representatives of key business functions complete the BIA. The final configuration will serve as the foundation for consistent data entry.",
        "descThirdParagraph": "Try to ensure equivalence between defined impacts across individual scales for different impact categories.",
        "descThirdExample": "(For example, a \"Serious\" value in the financial impact category should represent the same level of impact on your organisation as a \"Serious\" value in the operational impact category.)"
      },
      "riskAssessment": {
        "infoFirstParagraph": "Risk assessment should identify relevant threats, vulnerabilities, affected assets, and potential impacts.",
        "infoSecondParagraph": "Define the context clearly, evaluate likelihood and impact consistently, and document the reasoning behind each assessment.",
        "infoThirdParagraph": "Use the same criteria across assessments to support comparability, prioritisation, and defensible risk treatment decisions."
      },
      "vulnerabilitiesMeasures": {
        "title": "How to set the maturity level?",
        "infoFirstParagraph": "Assess maturity based on how consistently the measure is implemented, documented, and maintained.",
        "infoSecondParagraph": "Consider whether the measure is applied ad hoc, formally defined, managed through regular review, or continuously improved.",
        "infoThirdParagraph": "Use the same interpretation of each maturity level across the organisation to ensure consistent and comparable results."
      },
      "existingMeasure": {
        "title": "Existing measures"
      },
      "treatmentOptions": {
        "avoidanceDescription": "Avoid the risky activity entirely. Use this when the risk is too high.",
        "transferDescription": "Transfer the risk to another party (for example, insurance or a supplier). Suitable for significant risks.",
        "mitigationDescription": "Reduce the risk through preventive or corrective actions. Use this when the risk can be controlled.",
        "acceptanceDescription": "Accept the risk and continue. Suitable for low-impact or tolerable risks.",
        "cardInfoTitle": "Choose one strategy to handle this risk effectively.",
        "cardInfoLabel": "Tip"
      },
      "verification": {
        "increasedSecurityTitle": "Increased security:",
        "increasedSecurityDesc": "Relying solely on a password to protect your account can be risky, as passwords can be stolen, guessed, or otherwise compromised. Two-factor authentication provides an additional layer of security, making your account much harder for unauthorised individuals to access.",
        "identityTheftTitle": "Protection against identity theft:",
        "identityTheftDesc": "Because two-factor authentication requires not only a password but also additional verification, such as a code from SMS or an authentication app, it is less likely that someone could gain access to your account even if they obtain your password.",
        "showMore": "Show more"
      },
      "companyInfo": {
        "shortNameDesc": "The short company name will be displayed throughout the application."
      },
      "billingInfo": {
        "shortNameDesc": "The short company name will be displayed throughout the application."
      },
      "security": {
        "desc": "Configuring security settings helps protect your organisation from unauthorised access and potential threats. Regular review and updates of your security policies help ensure that your data remains protected and aligned with applicable standards.",
        "showMore": "Show more"
      }
    }
  },
  "completeness": {
    "completed": "Completed",
    "incomplete": "Incomplete",
    "notCovered": "Not covered",
    "notRelevant": "Not relevant",
    "covered": "Covered",
    "ignored": "Ignored"
  },
  "add": "Add",
  "next": "Next",
  "back": "Back",
  "discard": "Discard",
  "remove": "Remove",
  "save": "Save",
  "edit": "Edit",
  "cancel": "Cancel",
  "close": "Close",
  "archive": "Archive",
  "moreDetails": "More details",
  "infoMessage": "Information about the changes will be sent to all users for whom training is required.",
  "uploadFileLabel": "Upload file",
  "autocompleteSearchUserLabel": "Type a name or email",
  "autocompleteNoOptions": "No options",
  "orderBy": "Order by...",
  "filters": {
    "label": "Filters",
    "showResults": "Show results"
  },
  "emptyStateText": "No results found. Try adjusting your search or filter.",
  "footer": {
    "termsOfUse": "Terms of use",
    "privacyPolicy": "Privacy policy",
    "resources": "Resources",
    "rights": "All rights reserved."
  },
  "gapAnalysis": {
    "list": {
      "title": "Compliance",
      "complianceTrend": "Compliance trend",
      "complianceTrendDescription": "% compliant over time by framework",
      "table": {
        "name": "Name",
        "paragraph": "Paragraph",
        "description": "Description",
        "maturityLevel": "Self-assessed fulfilment level",
        "notes": "Notes",
        "complianceMeasures": "Compliance measures",
        "controls": "Controls",
        "coveringPolicies": "Covered by policies",
        "relatedNotes": "Related notes"
      },
      "maturityLevel": {
        "legend": {
          "1": "The legal requirement is fully met in scope and on time, without deficiencies.",
          "2": "Fulfilment is aligned with the legal requirement, with only minor formal or technical deviations that do not materially affect the content or purpose of the provision.",
          "3": "The provision is only partially fulfilled; some requirements are not met or are met only formally, and deficiencies need to be addressed.",
          "4": "Fulfilment is significantly limited or unsystematic; fundamental measures are required to ensure compliance.",
          "5": "Fulfilment of the relevant provision has not yet been ensured; implementation has not taken place or remains in the preparatory phase.",
          "N/A": "The provision does not apply to us."
        }
      }
    }
  },
  "cia": {
    "label": "CIA",
    "confidentiality": "Confidentiality",
    "integrity": "Integrity",
    "availability": "Availability",
    "c": "C",
    "i": "I",
    "a": "A"
  },
  "identificationDate": "Date of identification",
  "reviewPlanned": "Planned review",
  "button": {
    "getMeThere": "Get me there",
    "addConnection": "Add connection",
    "removeConnection": "Remove connection",
    "copy": "Copy",
    "copied": "Copied"
  },
  "form": {
    "titleLabel": "Title",
    "descriptionLabel": "Description"
  }
}
